import React from 'react'
import { Typography, TypographyProps } from '@mui/material'
import { formatDate } from 'utils/formatDate'
import { DATETIME_FORMAT, NA } from 'constans/common'
interface IDateTimeCellProps extends Omit<TypographyProps, 'children'> {
  value?: string
}

const DateTimeCell = ({ value, ...rest }: IDateTimeCellProps) => {
  return (
    <Typography
      {...rest}
      sx={{
        fontFamily: 'Nunito',
        fontWeight: 500,
        fontSize: '0.875rem',
        minWidth: 100,
        ...rest.sx,
      }}
    >
      {!value ? NA : formatDate(value, `${DATETIME_FORMAT} A`)}
    </Typography>
  )
}

export default DateTimeCell
